import React from 'react';
import '../Count/Count.css';

const LogoGrid = () => {
  const logos = [
    '/okaya.jpg',
    '/astra.jpg',
    '/escnet.png',
    '/Abbott.jpg',
    '/max.jpg',
    '/microtek.jpg',
    '/kpmg.jpg',
     '/dp.jpg',
    '/hcl.jpg',
    '/l8.png'
  ];

  return (
    <div className="logo-section">
      <div className="logo-container">
        {logos.map((logo, index) => (
          <img 
            key={index} 
            src={logo} 
            alt={`Company Logo ${index + 1}`} 
             loading="lazy" 
            className="logo-image"
            data-aos="flip-down"
          />
        ))}
      </div>
    </div>
  );
};

export default LogoGrid;